import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import XLSX from 'xlsx'
import {
  CentraisOperacaoDropdown,
  CustomAccordionTab,
  CustomDropdown,
  ImportXmlFiles,
  Loading,
  PageHeader,
  TextBtn,
} from '../../../../components'
import { Panel } from 'primereact/panel'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as ImportacaoHttp from '../../../../services/api/https/deliveries/importation.http'
import CardsResultadoImportacao from '../ImportacaoCicloEntrega/CardsResultadoImportacao'
import TabsClientesEhProdutosNaoCadastrados from '../ImportacaoCicloEntrega/TabsClientesEhProdutosNaoCadastrados'
import { getTiposDeArquivosDeImportacaoByIds } from '../../../../services/api/https/system/system.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { Accordion } from 'primereact/accordion'

const ShowMode = {
  MESSAGE: 'MESSAGE',
  LOADING: 'LOADING',
  CARDS: 'CARDS',
  TABS: 'TABS',
}
function ImportacaoMultiCicloEntregaXml({ history, dispatch, selectedTp }) {
  // Vars
  const central_operacional_id = history.location.state.central_operacional_id

  // Hooks
  const [state, setState] = useState({
    fileTypesOptions: [],
    selectedFileType: null,
    activeIndex: 0,
    result: [],
    centralOperacaoId: central_operacional_id,
  })
  const [showMode, setShowMode] = useState(ShowMode.MESSAGE)
  const [produtosSemCadastros, setProdutosSemCadastros] = useState([])
  const [produtosComInconsistencia, setProdutosComInconsistencia] = useState([])
  const [clientesSemCadastros, setClientesSemCadastros] = useState([])

  useEffect(() => {
    async function fetchInitialInfo() {
      const tipos = (await getTiposDeArquivosDeImportacaoByIds([18, 58, 93])).map(t => ({
        label: t.name,
        value: t.id,
        tipo: t.tipo,
      }))

      setState(prevState => ({ ...prevState, fileTypesOptions: tipos, selectedFileType: tipos[0] }))
    }
    fetchInitialInfo()
  }, [])

  // Events
  const onError = error => {
    dispatch(showMessageBox(null, error))
  }

  const onFileImportationSuccess = async data => {
    try {
      setShowMode(ShowMode.LOADING)
      const { id: user_id } = getUsuarioInfo()
      // const { qteDeliveries, qteIdentifiers, qteSkus, weight } =
      const ciclosCriados = await ImportacaoHttp.importDeliveriesMultiCicle(
        {
          info: data,
          operation_center_id: state.centralOperacaoId,
          tp_id: selectedTp,
        },
        state.selectedFileType.value,
        user_id,
      )

      setState(prevState => ({ ...prevState, result: ciclosCriados }))
      dispatch(showMessageBox('Importação realizada com sucesso', null))
      setShowMode(ShowMode.CARDS)
    } catch (error) {
      const {
        message,
        clientsNotSaved = [],
        productsNotSaved = [],
        productsWithInconsistency = [],
      } = error
      if (message) {
        dispatch(showMessageBox(null, message))
        if (
          clientsNotSaved.length > 0 ||
          productsNotSaved.length > 0 ||
          productsWithInconsistency.length > 0
        ) {
          setProdutosSemCadastros(productsNotSaved)
          setProdutosComInconsistencia(productsWithInconsistency)
          setClientesSemCadastros(clientsNotSaved)
          setShowMode(ShowMode.TABS)
        }
      } else {
        setShowMode(ShowMode.MESSAGE)
        dispatch(showMessageBox(null, error))
      }
    }
  }

  // Helpers
  const isExcelFileType = state.selectedFileType && state.selectedFileType.tipo === 'excel'

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Importação&nbsp;<strong>{isExcelFileType ? 'Excel' : 'XML'}</strong>&nbsp;-&nbsp;Ciclos de
        Entrega
      </PageHeader>

      <Panel
        header={
          <ImportacaoPanelHeader
            onSuccess={onFileImportationSuccess}
            onError={onError}
            onVoltar={history.goBack}
            isLoading={showMode === ShowMode.LOADING}
            isExcelFileType={isExcelFileType}
          />
        }
        style={{ marginTop: 20 }}
      >
        <div className="p-grid">
          <div className="p-col-4">
            <CustomDropdown
              marginTop={0}
              optionLabel="label"
              label="Tipo de Arquivo"
              options={state.fileTypesOptions}
              value={state.selectedFileType}
              onChange={value => setState({ ...state, selectedFileType: value })}
            />
          </div>
          <div className="p-col-4">
            <CentraisOperacaoDropdown
              showLabel={true}
              value={state.centralOperacaoId}
              onChange={value =>
                setState(prevState => ({ ...prevState, centralOperacaoId: value }))
              }
            />
          </div>

          <div className="p-col-12">
            {showMode === ShowMode.MESSAGE ? (
              <div style={{ textAlign: 'center', color: '#c4c4c4', fontWeight: 'bold' }}>
                Para realizar a importação, clique no botão Importar
              </div>
            ) : null}
            {showMode === ShowMode.CARDS ? (
              <Accordion
                activeIndex={state.activeIndex}
                onTabChange={value =>
                  setState(prevState => ({ ...prevState, activeIndex: value.index }))
                }
              >
                {state.result.map(item => {
                  const { importResult, cycle } = item
                  const headerTitle = `${cycle.id} - ${cycle.name}`
                  return (
                    <CustomAccordionTab header={headerTitle} key={cycle.id}>
                      <CardsResultadoImportacao
                        weight={importResult.weight}
                        qteSkus={importResult.qteSkus}
                        qteIdentifiers={importResult.qteIdentifiers}
                        qteDeliveries={importResult.qteDeliveries}
                      />
                    </CustomAccordionTab>
                  )
                })}
              </Accordion>
            ) : null}
            {showMode === ShowMode.TABS ? (
              <TabsClientesEhProdutosNaoCadastrados
                produtosSemCadastros={produtosSemCadastros}
                clientesSemCadastros={clientesSemCadastros}
                produtosComInconsistencia={produtosComInconsistencia}
              />
            ) : null}
            {showMode === ShowMode.LOADING ? <Loading /> : null}
          </div>
        </div>
      </Panel>
    </React.Fragment>
  )
}

function ImportacaoPanelHeader({ isLoading, onError, onSuccess, onVoltar, isExcelFileType }) {
  // Render
  return (
    <div className="p-grid">
      <div className="p-col-3">
        <div style={{ display: 'inline-block', position: 'relative', width: 80, height: 20 }}>
          <div
            className="text-center"
            style={{
              visibility: !isLoading ? 'visible' : 'hidden',
              position: 'absolute',
            }}
          >
            {isExcelFileType ? (
              <ImportExcelBtn onError={onError} onSuccess={onSuccess} />
            ) : (
              <ImportXmlFiles onError={onError} onSuccess={onSuccess} />
            )}
          </div>
          <div
            className="text-center"
            style={{
              visibility: isLoading ? 'visible' : 'hidden',
              position: 'absolute',
            }}
          >
            <Loading />
          </div>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <TextBtn onClick={onVoltar}>Voltar</TextBtn>
        </div>
      </div>
    </div>
  )
}

// Mesmo markup/estilo do ImportXmlFiles (botão .btnImportar), porém lendo um arquivo Excel
function ImportExcelBtn({ onSuccess, onError, label = 'Importar' }) {
  // Vars
  const inputFileRef = React.createRef()

  // Events
  const onInputFileChange = evt => {
    try {
      const file = evt.target.files[0]
      if (!file) throw new Error('Nenhum arquivo foi selecionado')

      const reader = new FileReader()
      reader.addEventListener('load', () => {
        try {
          const data = new Uint8Array(reader.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const firstWorksheet = workbook.Sheets[workbook.SheetNames[0]]
          const result = XLSX.utils.sheet_to_json(firstWorksheet, { header: 1 })
          onSuccess(result)
        } catch (e) {
          onError(e)
        }
      })
      reader.readAsArrayBuffer(file)
      evt.target.value = null
    } catch (e) {
      onError(e)
    }
  }
  const onBtnImportarClick = () => {
    inputFileRef.current.click()
  }

  // Render
  return (
    <div>
      <input
        type="file"
        accept=".csv, .xlsm, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.ms-excel.sheet.macroEnabled.12"
        onChange={onInputFileChange}
        ref={inputFileRef}
        style={{ display: 'none' }}
      />
      <button className="btnImportar" onClick={onBtnImportarClick}>
        {label}
      </button>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })

export default connect(mapStateToProps)(withRouter(ImportacaoMultiCicloEntregaXml))
